<template>
  <div class="wrap-school-of-creativity-detail">
    <b-row class="title">
      <b-col
        cols="12"
        md="8"
        class="text"
      >
        <h2>{{ propObj.title }}</h2>
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="btn"
      >
        <button @click="goBack">Back</button>
      </b-col>
    </b-row>

    <div class="time">
      <h3>{{ propObj.time }}</h3>
    </div>

    <b-row class="images">
      <b-col
        v-for="(imgUrl, i) in propObj.imgUrls"
        :key="i"
        cols="12"
        md="3"
        class="col"
      >
        <img :src="imgUrl">
      </b-col>
    </b-row>

    <div class="synopsis">
      <h4>Synopsis:</h4>
      <span v-html="propObj.content"></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      propObj: null
    }
  },

  computed: {
    ...mapState({
      schoolCreativesRaw: state => state.creativity.schoolCreatives
    })
  },

  methods: {
    mapDetail (data, id) {
      if (data) {
        data.forEach(schoolCreative => {
          if (schoolCreative.id === id.main) {
            schoolCreative.detail.forEach(detail => {
              if (detail.id === id.detail) {
                this.propObj = {
                  title: `${schoolCreative.name} ${schoolCreative.room}`,
                  time: `${detail.time_start} - ${detail.time_end}: ${detail.name}`,
                  content: detail.content,
                  imgUrls: []
                }

                detail.photo.forEach(photo => {
                  if (photo.image) {
                    const imgUrl = `https://admanawards.com/storage/app/img/talkdetailphoto/${photo.image}`
                    this.propObj.imgUrls.push(imgUrl)
                  }
                })
              }
            })
          }
        })
      }
    },

    goBack () {
      this.$router.go(-1)
    }
  },

  created () {
    const id = {
      main: this.$route.params.mainId,
      detail: this.$route.params.detailId
    }

    this.mapDetail(this.schoolCreativesRaw, id)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-school-of-creativity-detail {
  .title {
    padding-top: 22px;
    padding-bottom: 22px;
    align-items: center;

    .text {
      h2 {
        font-size: 1.5rem;
      }
    }

    .btn {
      button {
        width: 100%;
        height: 52px;
        background-color: $light;
        font-size: 1.5rem;
      }
    }
  }

  .time {
    padding: 15px 8px;
    background-color: $light;

    h3 {
      font-size: 1.25rem;
      color: black;
    }
  }

  .images {
    padding: 22px 0;

    .col {
      img {
        width: 100%;
      }
    }
  }

  .synopsis {
    padding-bottom: 22px;

    h4 {
      margin: 12px 0 0 0;
      font-size: 1.75rem;
    }

    span {
      line-height: 1.2;
      font-size: 1.5rem;
    }
  }
}
</style>
